import type { FaireProductEntity } from "../../entity_types/product";

export const p_bujcs4dmzn: FaireProductEntity = {
  token: "p_bujcs4dmzn",
  type: "product",
  name: "Only Child Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/8b6fbbf6571f49c2db108dc448d9978679ea04d2419e9c69a538639a75a21d4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f39b5360c4ed10d87126ccc68b734d60859ac2b7c7b023bd9271c26af886ec2b.jpeg",
    "https://cdn.faire.com/fastly/f61ad301994235d255a0409cf82f66bf21740e2ae90c16b1bb929bf740e6100a.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/dda1cb32bf4bd153332230a74697529e4cb3147ca23230071983aa08e70a86cf.jpeg",
    "https://cdn.faire.com/fastly/561b5e6614614be34763cef6e3a62dfee70083ef021abbd02a0994e91067f160.jpeg",
    "https://cdn.faire.com/fastly/a38f2cdd4c33cff9710f371e6308c9f2b240146ad9ab674167b6e5051f7a6ff2.jpeg",
    "https://cdn.faire.com/fastly/ccc2a8562698109fc7b1cfe40fa1215926274e75a02b07565f8ea23d6bed3f44.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for the self-sufficient legends that never learned to share.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:19.168Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
